<template>
    <div class="margin__top__20">
        <div class="row newpet__Form">
            <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                    <label for="exampleInputEmail1">Pet Name</label>
                    <input type="text" class="form-control" name="PetName" placeholder="Pet Name" v-model="PetName" id="PetName">
                    <span class="error" v-if="errors.indexOf('InvalidPetName')>-1">Pet name is required. </span>
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                    <label for="Color">Birth Date (MM/DD/YYYY)</label>
                    <input id="datepicker"  placeholder="Birth Date" class="form-control" v-model="dateOfBirth">
                    <span class="error" v-if="errors.indexOf('InvalidDate')>-1">Birth date is required. </span>
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                    <label for="Color">Color</label>
                    <input type="text" class="form-control" name="PetName" placeholder="Color" v-model="Color" id="Color">
                    <span class="error" v-if="errors.indexOf('InvalidColor')>-1">Color is required. </span>
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                    <label for="SelectedSpeciesControl">Species</label>
                    <select id="SelectedSpeciesControl" class="form-control" v-model="SelectedSpecies">
                        <option :SelectedSpecies="true">-- Select --</option>
                        <option v-for="(item,counter) in species" v-bind:value="item" v-bind:key="counter">
                            {{item.Name}}
                        </option>
                    </select>
                    <span class="error" v-if="errors.indexOf('InvalidSpecies')>-1">Species is required. </span>
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                    <label for="SelectedBreedControl">Breed</label>
                    <select id="SelectedBreedControl" class="form-control" v-model="SelectedBreed">
                        <option :SelectedBreed="true">-- Select --</option>
                        <option v-for="(item,counter) in SelectedSpecies.Breeds" v-bind:value="item" v-bind:key="counter">
                            {{item.Name}}
                        </option>
                    </select>
                    <span class="error" v-if="errors.indexOf('InvalidBreed')>-1">Breed is required. </span>
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12">
                <div class="form-group">
                    <label for="SelectedSexControl">Sex</label>
                    <select id="SelectedSexControl" class="form-control" v-model="SelectedSex">
                        <option :SelectedBreed="true">-- Select --</option>
                        <option v-for="(item,counter) in sexes" v-bind:value="item" v-bind:key="counter">
                            {{item.Name}}
                        </option>
                    </select>
                    <span class="error" v-if="errors.indexOf('InvalidSex')>-1">Sex is required. </span>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-6">
                <button class="btn btn__secondary" @click="goBack()">Previous</button>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-6 ">
                <button class="btn btn__primary pull-right" @click="MoveToNextPage">Next</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'NewPet',
    created() {
        this.$store.dispatch('SetPageNumber', 3);
    },
    mounted: function() {
      var self = this;
      console.log('mounted');
      $('#datepicker').datepicker({
          dateFormat : 'mm/dd/yy',
            changeMonth : true,
            changeYear : true,
            yearRange: '-100y:c+nn',
            onClose:function(selectedDate, datePicker) {            
                self.$store.commit('UpdateDateOfBirth', selectedDate)
            }
        });
    },
    data() {
        return {
            errors: [] 
        }
    },
    methods: {
        goBack() {
            this.$router.replace({ name: 'PetOwnerDetails' })
        },
        MoveToNextPage(e) {
            this.errors = [];
            if (!this.PetName || this.PetName == '') {
                this.errors.push("InvalidPetName");
            }
            if (!this.SelectedSpecies || this.SelectedSpecies == '-- Select --') {
                this.errors.push("InvalidSpecies");
            }

            if (!this.SelectedBreed || this.SelectedBreed == '-- Select --') {
                this.errors.push("InvalidBreed");
            }

            if (!this.SelectedSex || this.SelectedSex == '-- Select --') {
                this.errors.push("InvalidSex");
            }

            if (!this.Color || this.Color == '') {
                this.errors.push("InvalidColor");
            }

            if (!this.formattedDateOfBirth) {
                this.errors.push("InvalidDate");
            }
          

            if (this.errors.length > 0) {
                e.preventDefault();
            }
            else {
                this.$store.dispatch('SetSelectedPet', this.newPetForm);
                this.$router.push({ name: 'PetServices' })
            }
        }
    },
    computed: {
        ...mapGetters({
            species: 'species',
            sexes: 'sexes',
            newPetForm: 'newPetForm',
            formattedDateOfBirth:'formattedDateOfBirth',
            dateOfBirth:'dateOfBirth'
        }),
        PetName: {
            get() {
                return this.$store.state.NewPetForm.Name
            },
            set(value) {
                this.$store.commit('UpdatePetName', value)
            }
        },
        SelectedSpecies: {
            get() {
                return this.$store.state.NewPetForm.Species
            },
            set(value) {
                this.$store.commit('UpdateSpecies', value)
            }
        },
        SelectedBreed: {
            get() {
                return this.$store.state.NewPetForm.Breed
            },
            set(value) {
                this.$store.commit('UpdateBreed', value)
            }
        },
        SelectedSex: {
            get() {
                return this.$store.state.NewPetForm.Sex
            },
            set(value) {
                this.$store.commit('UpdateSex', value)
            }
        },
        Color: {
            get() {
                return this.$store.state.NewPetForm.Color
            },
            set(value) {
                this.$store.commit('UpdateColor', value)
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/NewPet.vue